module.exports = __webpack_public_path__ + "static/media/cci.0bbf1b27.png";